module.exports = require("./es-VE.d.ts");